import { render, staticRenderFns } from "./ExchangeRateIndex.vue?vue&type=template&id=5b17c0d2"
import script from "./ExchangeRateIndex.vue?vue&type=script&lang=js"
export * from "./ExchangeRateIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports